import { render, staticRenderFns } from "./CX-bmw.vue?vue&type=template&id=95323042&scoped=true&"
import script from "./CX-bmw.vue?vue&type=script&lang=js&"
export * from "./CX-bmw.vue?vue&type=script&lang=js&"
import style0 from "./CX-bmw.vue?vue&type=style&index=0&id=95323042&prod&lang=scss&"
import style1 from "./CX-bmw.vue?vue&type=style&index=1&id=95323042&prod&lang=scss&scoped=true&"
import style2 from "./CX-bmw.vue?vue&type=style&index=2&id=95323042&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95323042",
  null
  
)

export default component.exports